import { useState, useEffect, useCallback } from 'react';
import { getClientes, getCliente } from '../services/api';
import { PageHeader, SearchBar, Table, Loading, Erro, Badge, Paginacao } from '../components/UI';
import './Clientes.css';

const LIMITE = 50;

const colunas = [
  { key: 'ID',       label: 'ID',           width: 60,  render: v => <span style={{color:'var(--text-dim)',fontSize:12}}>{v}</span> },
  { key: 'RAZAO',    label: 'Razão Social',  width: 250, render: v => <strong>{v||'—'}</strong> },
  { key: 'FANTAZIA', label: 'Fantasia',      width: 200 },
  { key: 'CNPJCPF',  label: 'CPF/CNPJ',     width: 150, render: v => <span style={{fontFamily:'monospace',fontSize:12}}>{v||'—'}</span> },
  { key: 'CIDADE',   label: 'Cidade',        width: 150 },
  { key: 'ESTADO',   label: 'UF',            width: 50 },
  { key: 'TELEFONE1',label: 'Telefone',      width: 130, render: v => <span style={{fontFamily:'monospace',fontSize:12}}>{v||'—'}</span> },
  { key: 'STATUS',   label: 'Status',        width: 85,  render: v => { const a=v==='S'||v===1||v==='A'; return <Badge valor={a?'Ativo':'Inativo'} tipo={a?'success':'danger'} />; } },
];

function Campo({ label, valor }) {
  return <div className="det-campo"><span className="det-label">{label}</span><span className="det-valor">{valor||'—'}</span></div>;
}

export default function Clientes() {
  const [busca,  setBusca]  = useState('');
  const [dados,  setDados]  = useState([]);
  const [load,   setLoad]   = useState(false);
  const [erro,   setErro]   = useState('');
  const [offset, setOffset] = useState(0);
  const [sel,    setSel]    = useState(null);
  const [loadD,  setLoadD]  = useState(false);

  const carregar = useCallback(async (b=busca, o=offset) => {
    setLoad(true); setErro('');
    try { setDados(await getClientes(b, LIMITE, o)); }
    catch(e) { setErro(e.message); }
    finally { setLoad(false); }
  }, [busca, offset]);

  useEffect(() => { carregar(); }, [offset]);
  useEffect(() => {
    const t = setTimeout(() => { setOffset(0); carregar(busca, 0); }, 400);
    return () => clearTimeout(t);
  }, [busca]);

  const abrirCliente = async (row) => {
    setLoadD(true); setSel(null);
    try { setSel(await getCliente(row.ID)); }
    catch { setSel(row); }
    finally { setLoadD(false); }
  };

  return (
    <div className="cli-layout">
      <div className="cli-lista">
        <PageHeader titulo="Clientes" subtitulo={`${dados.length} registros exibidos`}>
          <SearchBar value={busca} onChange={setBusca} placeholder="Nome, fantasia ou CPF/CNPJ..." />
        </PageHeader>
        {erro && <Erro mensagem={erro} onRetry={carregar} />}
        {load ? <Loading /> : <>
          <Table colunas={colunas} dados={dados} onRowClick={abrirCliente} vazio="Nenhum cliente encontrado." />
          <Paginacao offset={offset} limite={LIMITE} total={dados.length} onChange={setOffset} />
        </>}
      </div>
      {(sel || loadD) && (
        <div className="cli-det fade-in">
          <div className="det-header">
            <span className="det-titulo">Dados do Cliente</span>
            <button className="det-fechar" onClick={() => setSel(null)}>✕</button>
          </div>
          {loadD ? <Loading /> : sel && (
            <div className="det-corpo">
              <div className="det-avatar">{sel.RAZAO?.[0]?.toUpperCase()||'?'}</div>
              <div className="det-nome">{sel.RAZAO}</div>
              {sel.FANTAZIA && <div className="det-fantasia">{sel.FANTAZIA}</div>}
              <div className="det-campos">
                <Campo label="CPF/CNPJ"  valor={sel.CNPJCPF} />
                <Campo label="IE/RG"     valor={sel.IERG} />
                <Campo label="Telefone"  valor={sel.TELEFONE1} />
                <Campo label="E-mail"    valor={sel.EMAIL} />
                <Campo label="Endereço"  valor={[sel.ENDERECO,sel.NUMERO,sel.COMPLEMENTO].filter(Boolean).join(', ')} />
                <Campo label="Bairro"    valor={sel.BAIRRO} />
                <Campo label="Cidade/UF" valor={sel.CIDADE&&sel.ESTADO?`${sel.CIDADE} — ${sel.ESTADO}`:sel.CIDADE||sel.ESTADO} />
                <Campo label="CEP"       valor={sel.CEP} />
                <Campo label="Status"    valor={sel.STATUS} />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
